export default __webpack_public_path__ + "static/media/bg-pattern-how-we-work-mobile.96cd9d06.svg";